import type { SVGProps } from 'react';

const SvgInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 16 16'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      clipRule='evenodd'
      d='M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0ZM8 4a.5.5 0 0 1 .5.5V9a.5.5 0 0 1-1 0V4.5A.5.5 0 0 1 8 4Zm0 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z'
      fill='currentColor'
      fillRule='evenodd'
    />
  </svg>
);
export default SvgInfo;
